








































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Modal from '@/components/common/Modal.vue';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';
import { validateNotEmpty } from '@/utils/form-validation';

@Component({
  components: {
    Modal,
    BeatLoader,
  },
})
export default class ModalAddCollection extends Vue {
  @Prop()
  showAddCollection!: boolean;

  @Prop()
  closeAddCollection!: (refetchCollections: boolean) => Promise<void>;

  @Prop()
  createCollection!: (name: string) => Promise<void>;

  width = '800px';
  title = 'Add new collection';
  description = `Create a new collection to collect questions. 
  You can choose any name for your collection. For example, final midterm exam.`;

  isLoading = false;

  nameInput = '';
  nameInputLength = this.nameInput.length;
  nameError: string | boolean = false;

  async addCollectionSubmitted() {
    if (this.isLoading) return;
    this.isLoading = true;

    let hasError = false;

    if (!validateNotEmpty(this.nameInput)) {
      this.nameError = 'Collection name cannot be empty';
      hasError = true;
    } else {
      this.nameError = false;
    }

    if (hasError) {
      this.isLoading = false;
      return;
    }

    await this.createCollection(this.nameInput);
    this.nameInput = '';
    this.closeAddCollection(true);
    this.isLoading = false;
  }

  @Watch('nameInput')
  currentNameInputLength() {
    this.nameInputLength = this.nameInput.length;
  }
}
